import { useQuery } from '@apollo/client';

import { QueryHookOptions } from '../..';
import { ROAD_DISTANCE } from '../geoTypeDefs';

export const useQueryGetRoadDistance = (options?: QueryHookOptions<typeof ROAD_DISTANCE>) => (
  useQuery(ROAD_DISTANCE, options)
);
